module.exports = __webpack_public_path__ + "img/Picture9.fe3bd08c.jpg";